<div class="padding">
  <br />
  <a mat-raised-button class="mat-accent" (click)="onSaveButtonClick();">{{ saveButtonText }}</a>
  <br />
  @if (validationErrors && validationErrors.length !== 0) {
    <div class="state-validation-errors">
      <h4>Validation Errors</h4>
      <ul>
        @for (validationError of validationErrors; track validationError) {
          <li>{{ validationError }}</li>
        }
      </ul>
    </div>
  }
  <br />
  <br />
  <h1>State Properties</h1>
  <br />
  <div>
    <mat-form-field class="state-editor-mediumfield state-editor-marginright">
      <mat-label>Step</mat-label>
      <mat-select matInput #nodeSelection="ngModel" [(ngModel)]="selectedStep">
        @for (step of getModuleContentSteps() | async; track step) {
          <mat-option [value]="step">
            {{ prettifyLabel(step.StepName) }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (selectedStep != null) {
      <mat-form-field class="state-editor-mediumfield state-editor-marginright">
        <mat-label>Field</mat-label>
        <mat-select matInput #nodeSelection="ngModel" [(ngModel)]="selectedField">
          @for (field of getModuleContentStepFields(selectedStep.StepId) | async; track field) {
            <mat-option [value]="field">
              {{ prettifyLabel(field.FieldName) }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (selectedStep != null && selectedField != null) {
      <div>
        @if (!selectedField.IsMandatory) {
          <mat-card class="warning">
            <mat-icon class="icon-white" inline="true">warning</mat-icon>
            <span>Changing the settings here will not take effect until this field has been set to
            mandatory in Steps -> Rules.</span>
          </mat-card>
        }
        <br />

        <table>
          <thead>
            <tr>
              <td>State</td>
              <td>
                Mandatory only at state
                <br />
                <mat-checkbox
                  [checked]="allMandatorySelected()"
                  [indeterminate]="someMandatorySelected()"
                  (change)="toggleSelectAllMandatory($event.checked)">
                  Select/Deselect All
                </mat-checkbox>
              </td>
              @if (selectedField?.IsCustomField) {
                <td>
                  Editable field
                  <br />
                  <mat-checkbox
                    [checked]="allEditableSelected()"
                    [indeterminate]="someEditableSelected()"
                    (change)="toggleSelectAllEditable($event.checked)">
                    Select/Deselect All
                  </mat-checkbox>
                </td>
              }
            </tr>
          </thead>
          <tbody>
            @for (stateNode of stateNodes; track stateNode) {
              <tr>
                <td>{{ prettifyLabel(stateNode.Name) }}</td>
                <td>
                  <mat-checkbox
                    [checked]="fieldIsMandatoryAtState(selectedField, stateNode)"
                    (change)="updateFieldIsMandatoryAtState(selectedField, stateNode, $event.checked)">
                  </mat-checkbox>
                </td>
                @if (selectedField?.IsCustomField) {
                  <td>
                    <mat-checkbox
                      [checked]="fieldIsEditableAtState(selectedField, stateNode)"
                      (change)="updateFieldIsEditableAtState(selectedField, stateNode, $event.checked)">
                    </mat-checkbox>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
  <br />
  <h1>Transition Properties</h1>
  <br />
  <div>
    <!--
    <div *ngIf="moduleService.moduleStateContent">
      <aw-state-viewer [stateData]="moduleService.moduleStateContent"></aw-state-viewer>
    </div>
    -->
    <mat-form-field class="state-editor-mediumfield state-editor-marginright">
      <mat-label>From</mat-label>
      <mat-select matInput #nodeSelection="ngModel" [(ngModel)]="stateNodeFromId">
        @for (stateNode of stateNodes; track stateNode) {
          <mat-option [value]="stateNode.ModuleStatus.Id">
            {{prettifyLabel(stateNode.Name)}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="state-editor-mediumfield">
      <mat-label>To</mat-label>
      <mat-select matInput #nodeSelection="ngModel" [(ngModel)]="stateNodeToId">
        @for (stateNode of getStateNodeToOptions(); track stateNode) {
          <mat-option [value]="stateNode.ModuleStatus.Id">
            {{prettifyLabel(stateNode.Name)}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <br />
  @if (stateNodeFromId && stateNodeToId) {
    <div>
      <h4>Transitions <button mat-icon-button (click)="onAddTransitionButtonClick()"><mat-icon>add</mat-icon></button></h4>
      @for (transition of getStateTransitions(); track transition) {
        <my-modules-transition
          [moduleId]="moduleId"
          [stateNodes]="stateNodes"
          [stateNodeFromId]="stateNodeFromId"
          [transition]="transition"
          [stateRules]="stateRules"
          [stateRulesToSave]="stateRulesToSave"
          [conditionFields]="conditionFields"
          [listItemsCache]="listItemsCache">
        </my-modules-transition>
      }
    </div>
  }
</div>